module.exports = __webpack_public_path__ + "static/desktop-1c0c4ecb485ecc40a9f2a1d688f5565c.jpg";